import React, { useEffect } from "react";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import { useStateIfMounted } from "use-state-if-mounted";
import { useLocation, useHistory } from "react-router-dom";
import ParametersView from "../parametersView/parameters_view";
import ReactDOM from "react-dom/client";

// React 18: ReactDOM.render(element, container) became
// ReactDOM.createRoot(container).render(element). A container may only have one
// root, and this view re-renders into the same container every time a list is
// toggled open, so roots are cached per container element and reused.
const __reactRoots = new WeakMap();
function renderIntoContainer(container, element) {
  let root = __reactRoots.get(container);
  if (!root) {
    root = ReactDOM.createRoot(container);
    __reactRoots.set(container, root);
  }
  root.render(element);
}

export const Parameters = (props) => {
  //const history = useHistory();
  const mac = mqtt_topics.choosenmac;
  const location = useLocation();
  const parameterscategorytopic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    mqtt_topics.parameters_category_command;
  const [state, setState] = useStateIfMounted({
    parameters_categories: [],
  });

  function requestparameterscategorydata() {
    if (location.mqttClient != undefined) {
      mqtt_topics.busy_Requesting_Data = true;
      location.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        mqtt_topics.parameters_category_command
      );
      mqtt_topics.busy_Requesting_Data = false;
      location.mqttClient.subscribe(parameterscategorytopic);
      location.mqttClient.on("message", handleMqttMessage);
    }
  }

  function handleMqttMessage(topic, message) {
    if (topic == parameterscategorytopic) {
      try {
        message = JSON.parse(message.toString());
        setState({
          parameters_categories: message,
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }

  function returnparameterpasswordindex(enteredpass) {
    if (enteredpass == "SAS") {
      return 5;
    } else if (enteredpass == "Senior") {
      return 4;
    } else if (enteredpass == "Client") {
      return 3;
    } else if (enteredpass == "User") {
      return 2;
    } else {
      return 0;
    }
  }

  function handleListClick(listid) {
    // Hide all *_View elements first
    document.querySelectorAll("[id$='_View']").forEach((el) => {
      if (el.id !== listid + "_View") {
        el.style.display = "none";
      }
    });

    const target = document.getElementById(listid + "_View");

    if (target.style.display.indexOf("block") === -1) {
      target.style.display = "block";

      renderIntoContainer(
        target,
        <React.StrictMode>
          <ParametersView
            key={listid + "_Key"}
            authlevel={returnparameterpasswordindex(
              props.location.enteredpasswordauthoritylevel
            )}
            viewId={listid}
            mqttClient={location.mqttClient}
          />
        </React.StrictMode>
      );

      // Add to watch list if needed
      if (
        !mqtt_topics.categories_User_Iswatching.includes(
          listid.replace("_", " ")
        )
      ) {
        mqtt_topics.categories_User_Iswatching.push(listid.replace("_", " "));
      }
    } else {
      target.style.display = "none";

      // Remove from watch list
      const index = mqtt_topics.categories_User_Iswatching.indexOf(
        listid.replace("_", " ")
      );
      if (index !== -1) {
        mqtt_topics.categories_User_Iswatching.splice(index, 1);
      }
    }
  }

  /*function handleListClick(listid) {
    if (
      document
        .getElementById(listid + "_View")
        .style.display.indexOf("block") === -1
    ) {
      document.getElementById(listid + "_View").style.display = "block";
      ReactDOM.render(
        <React.StrictMode>
          <ParametersView
            key={listid + "_Key"}
            authlevel={returnparameterpasswordindex(
              props.location.enteredpasswordauthoritylevel
            )}
            viewId={listid}
            mqttClient={location.mqttClient}
          />
        </React.StrictMode>,
        document.getElementById(listid + "_View")
      );
    } else {
      document.getElementById(listid + "_View").style.display = "none"; //.replace("_", " ")

      mqtt_topics.categories_User_Iswatching.splice(
        mqtt_topics.categories_User_Iswatching.indexOf(
          listid.replace("_", " ")
        ),
        1
      ); //remove
    }
  }*/

  useEffect(() => {
    //ask for how to display
    if (!mqtt_topics.busy_Requesting_Data) {
      requestparameterscategorydata();
    } else {
      setTimeout(function () {
        requestparameterscategorydata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
    //close a pending old topic:
    if (mqtt_topics.categories_User_Iswatching.length > 0) {
      location.mqttClient.publish(
        mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
        JSON.parse(
          JSON.stringify(
            '{ "' +
              mqtt_topics.finishedofalllivereadings +
              '" : [' +
              mqtt_topics.categories_User_Iswatching +
              "] }"
          )
        )
      );
      /*if (mac == "0-6c-74") {
        //mac for sas45k to close volsas
        location.mqttClient.publish(
          mqtt_topics.fixed_topic_part + "0-5c-98" + mqtt_topics.request_topic,
          JSON.parse(
            JSON.stringify(
              '{ "' +
                mqtt_topics.finishedofalllivereadings +
                '" : [' +
                mqtt_topics.categories_User_Iswatching +
                "] }"
            )
          )
        );
      }*/
      mqtt_topics.categories_User_Iswatching = [];
    }
    //close a pending old topic
  }, []);

  useEffect(
    () => () => {
      location.mqttClient.unsubscribe(parameterscategorytopic);
      location.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  if (state.parameters_categories.length > 0) {
    return (
      <div>
        <div className="container">
          <div className="row loginrow">
            <div className="col">
              <div className=" d-flex justify-content-start align-items-center position-relative">
                <button
                  type="button"
                  onClick={() => window.history.back()}
                  className="close text-white"
                  title="Back"
                  style={{ zIndex: 1 }}
                >
                  &#x3c;&#x3c;
                </button>
                <div className="text-center w-100 text-white">
                  <center>
                    <strong>
                      Parameters logged with:{" "}
                      {props.location.enteredpasswordauthoritylevel} Password
                    </strong>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {state.parameters_categories.map((list) =>
            list.vis != undefined ? (
              returnparameterpasswordindex(
                props.location.enteredpasswordauthoritylevel
              ) >= list.vis ? (
                //object array
                <React.StrictMode key={list.name.replace(" ", "_") + "_row"}>
                  <div className="container parameterstabs">
                    <div className="row">
                      <div className="col">
                        <div
                          className="card-header "
                          onClick={() =>
                            handleListClick(list.name.replace(" ", "_"))
                          }
                        >
                          <strong>{list.name}</strong>
                        </div>
                      </div>
                    </div>
                    <div
                      id={list.name.replace(" ", "_") + "_View"}
                      style={{ display: "none" }}
                    ></div>
                  </div>
                </React.StrictMode>
              ) : null
            ) : (
              //string array
              <React.StrictMode
                key={list.toString().replace(" ", "_") + "_row"}
              >
                <div className="container unselectable parameterstabs">
                  <div className="row">
                    <div className="col">
                      <div
                        className="card-header"
                        onClick={() =>
                          handleListClick(list.toString().replace(" ", "_"))
                        }
                      >
                        <strong>{list.toString()}</strong>
                      </div>
                    </div>
                  </div>
                  <div
                    id={list.toString().replace(" ", "_") + "_View"}
                    style={{ display: "none" }}
                  ></div>
                </div>
              </React.StrictMode>
            )
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading Parameters Category ...</strong>
          </p>
        </center>
      </div>
    );
  }
};
